import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {StyledReadonlySubRegimeField} from '@/features/projects/components/project-form/project-care-fields/style'
import {useTranslation} from '@/translations/i18n'

export const ProjectCareSubRegimeEmpty = () => {
    const {t} = useTranslation()
    return (
        <GridItem spanColumn={1} direction="column" gap={1.5} fullWidth>
            <Text palette="neutral" shade="500" weight="500" size="textSm">
                {t('commons:care_sub_regime')}
            </Text>
            <StyledReadonlySubRegimeField size="textSm">-</StyledReadonlySubRegimeField>
        </GridItem>
    )
}
